module.exports = __webpack_public_path__ + "static/GazanfarIbrahim-c9a143cd84afa831f919fd3cf82da676.jpg";